import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import planService from "../../services/planService";
import { getPendingPlan } from "../../utils/pendingPlan";
import { isYearlyPlan } from "../../utils/planPricing";
// The pricing page on mytamilkart.com, where "Change plan" goes back to
import { SITE_URL } from "../../utils/siteUrl";


const Tick = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10" /></svg>
);

// The plan picked on mytamilkart.com, if it is an active yearly plan:
// { plan, tier } where tier is its place among the yearly plans by price,
// cheapest first (0 Starter, 1 Pro, 2 Premium), which picks its feature list.
// plans/list is in Plan Management's sort order, which needn't follow price.
// null while loading, or with no such plan (the form then shows alone).
export const usePendingPlan = () => {
    const [picked, setPicked] = useState(null);

    useEffect(() => {
        const id = getPendingPlan();
        if (!id) return undefined;
        let active = true;
        planService.ensurePlansLoaded()
            .then((plans) => {
                const yearly = (Array.isArray(plans) ? plans : [])
                    .filter(p => isYearlyPlan(p) && p.is_active !== false)
                    .sort((a, b) => Number(a.price) - Number(b.price));
                const index = yearly.findIndex(p => String(p.plan_id) === id);
                if (active && index >= 0) setPicked({ plan: yearly[index], tier: Math.min(index, 2) });
            })
            .catch(() => { /* no plans: sign up works as usual */ });
        return () => { active = false; };
    }, []);

    return picked;
};

// "Your plan" beside the sign-up form: name, what it includes, and a link back
// to the pricing page to pick another one
const PlanSummary = ({ picked }) => {
    const { t } = useTranslation();
    const { plan, tier } = picked;
    const features = t(`auth.plan_features.${tier}`, { returnObjects: true });
    const changeUrl = `${SITE_URL}/plan?plan=${encodeURIComponent(plan.plan_id)}&lang=${i18n.language === "ta" ? "ta" : "en"}`;

    return (
        <aside className="plansum side" aria-labelledby="h-plan">
            <div className="ps-h">
                <span className="ps-k">{t("auth.your_plan")}</span>
                <h2 id="h-plan">{plan.name}</h2>
            </div>
            <ul>
                {(Array.isArray(features) ? features : []).map(feature => (
                    <li key={feature}><Tick /><span>{feature}</span></li>
                ))}
            </ul>
            <a className="ps-ch" href={changeUrl}>{t("auth.change_plan")}</a>
        </aside>
    );
};

export default PlanSummary;
